import { render } from "./PromosView.vue?vue&type=template&id=835ffb52"
import script from "./PromosView.vue?vue&type=script&lang=js"
export * from "./PromosView.vue?vue&type=script&lang=js"

import "./PromosView.vue?vue&type=style&index=0&id=835ffb52&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__